// Sales Cabinet login — email+password against POST /auth/login.
// Redirects to /dashboard on success, shows inline error otherwise.

import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { login, isAuthed } from "../lib/auth";

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // If already logged in, skip straight to dashboard.
  if (isAuthed()) {
    setTimeout(() => navigate("/dashboard", { replace: true }), 0);
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h1>Evimiz Sales</h1>
        <p className="subtitle">Вход только для meta-admin пользователей.</p>

        {error && <div className="error-banner">{error}</div>}

        <div className="form-row">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="form-row">
          <label htmlFor="password">Пароль</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
        </div>

        <button type="submit" disabled={loading} style={{ width: "100%", marginTop: 12 }}>
          {loading ? "Входим…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
